import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import JsonLd from '@/components/feature/JsonLd';
import { useSeo } from '@/hooks/useSeo';
import HeroSection from '@/pages/home/components/HeroSection';
import HotRanking from '@/pages/home/components/HotRanking';
import CategoryStrip from '@/pages/home/components/CategoryStrip';
import LatestGrid from '@/pages/home/components/LatestGrid';
import GraphicFeature from '@/pages/home/components/GraphicFeature';
import TopicSection from '@/pages/home/components/TopicSection';
import VoicesSection from '@/pages/home/components/VoicesSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';
import { articles } from '@/mocks/articles';
import { brand } from '@/mocks/site';

const sortedByDate = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1));
const hotArticles = [...articles].sort((a, b) => b.views - a.views).slice(0, 6);
const featured = articles[0];
const secondary = articles.slice(1, 4);
const latest = sortedByDate.slice(0, 6);
const graphicItems = [articles[2], articles[6], articles[9]];
const followUp = articles[6];

export default function Home() {
  useSeo({
    title: '揭秘局 - 独家揭秘深度内幕与线报图解门户',
    description:
      '揭秘局同步独家揭秘深度内幕与独家揭秘线报，用图解与信息图还原事件脉络，持续跟进每一波后续反映，帮吃瓜党快速补全线索变化。',
    keywords: '独家揭秘,独家揭秘深度内幕,独家揭秘线报,后续反映,图解,信息图',
    path: '/',
    image: featured.cover,
  });

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: brand.name,
    alternateName: brand.fullName,
    url: window.location.origin,
    description: brand.intro,
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${window.location.origin}/feed?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: brand.name,
    url: window.location.origin,
    description: brand.intro,
    email: brand.email,
    foundingDate: brand.founded,
    slogan: brand.slogan,
  };

  const listSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '24 小时热榜',
    itemListElement: hotArticles.map((article, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: `${window.location.origin}/article/${article.slug}`,
      name: article.title,
    })),
  };

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full">
        <HeroSection featured={featured} sideArticles={secondary} />
        <HotRanking hotArticles={hotArticles} followUp={followUp} />
        <CategoryStrip />
        <LatestGrid latest={latest} />
        <GraphicFeature items={graphicItems} />
        <TopicSection />
        <VoicesSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
      <JsonLd id="ld-home-website" data={websiteSchema} />
      <JsonLd id="ld-home-org" data={organizationSchema} />
      <JsonLd id="ld-home-list" data={listSchema} />
    </div>
  );
}